var currency = require( '../global/currency' );

var attended_course_add_to_cart = (function( $ ) {

	var anim_speed = 400,
		notice_class = 'crate-woo-notice',
		is_scrolling = false,
		scroll_speed = 700;

	var _init = function() {
		setup_form();
	};

	var setup_form = function() {
		var $wrapper = $( '.attended-course-info' ), $form = $wrapper.find( 'form' );

		$wrapper.addClass( 'loading' );

		setTimeout( () => {
			$wrapper.removeClass( 'loading' );
		}, 300 );

		$form.on( 'submit', ( e ) => {
			e.preventDefault();
			submit_form( $form )
		} );

		update_visible_information( $form );

		$form.find( 'select#attended-course-date-select' ).on( 'change', function( e ) {
			update_visible_information( $form );
		} );

		$form.find( 'input#pay-in-instalments-checkbox' ).on( 'change', function( e ) {
			update_visible_information( $form );
		} );

		setup_book_button_click();

		if ( $( '.custom-qty-toggle-buttons' ).length > 0 ) {
			setup_custom_qty_inputs();
		}
	}

	var setup_book_button_click = function() {
		$( 'button.button-attended-course' ).on( 'click', function( e ) {
			e.preventDefault();

			$( this ).closest( '.attended-course-info' ).find( 'form' ).trigger( 'submit' );
		} );
	}

	var setup_custom_qty_inputs = function() {
		var $wrapper = $( '.custom-qty-toggle-buttons' ),
			$default_input = $wrapper.closest( '.attended-course-info' ).find( 'form .quantity' );

		set_classes( $wrapper );

		$wrapper.find( 'a.plus' ).on( 'click', ( e ) => {
			e.preventDefault();

			plus_click( $wrapper, $default_input );
		} );

		$wrapper.find( 'a.minus' ).on( 'click', ( e ) => {
			e.preventDefault();

			minus_click( $wrapper, $default_input );
		} );

		$default_input.on( 'change', () => {
			update_quantity( $wrapper, $default_input );
			set_classes( $wrapper );
		} );
	}

	var set_classes = function( $wrapper ) {
		var current_value = parseInt( $wrapper.data( 'value' ) ), $plus = $wrapper.find( 'a.plus' ),
			$minus = $wrapper.find( 'a.minus' ), minQty = parseInt( $minus.data( 'min' ) ),
			max_qty = parseInt( $plus.data( 'max' ) );

		if ( max_qty !== -1 ) {
			if ( current_value === max_qty ) {
				$plus.addClass( 'disabled' );
			} else {
				$plus.removeClass( 'disabled' );
			}
		}

		if ( minQty ) {
			if ( current_value === minQty || current_value < minQty ) {
				$minus.addClass( 'disabled' );
			} else {
				$minus.removeClass( 'disabled' );
			}
		}
	}

	var update_quantity = function( $wrapper, $default_input ) {
		$( '.attended-course-info' ).addClass( 'loading' );

		var value = $default_input.find( 'input[type="number"]' ).val();

		$wrapper.data( 'value', value );
		$wrapper.find( '.qty-num' ).text( value );

		setTimeout( () => {
			$( '.attended-course-info' ).removeClass( 'loading' );
		}, 300 );
	}

	var plus_click = function( $wrapper, $default_input_wrapper ) {
		if ( $wrapper.find( 'a.plus' ).hasClass( 'disabled' ) ) {
			return;
		}

		var current_value = parseInt( $wrapper.data( 'value' ) );

		$default_input_wrapper.find( 'input[type="number"]' ).val( current_value + 1 );
		$default_input_wrapper.find( 'input[type="number"]' ).trigger( 'change' );
	}

	var minus_click = function( $wrapper, $default_input_wrapper ) {
		if ( $wrapper.find( 'a.minus' ).hasClass( 'disabled' ) ) {
			return;
		}

		var current_value = parseInt( $wrapper.data( 'value' ) );

		$default_input_wrapper.find( 'input[type="number"]' ).val( current_value - 1 );
		$default_input_wrapper.find( 'input[type="number"]' ).trigger( 'change' );
	}

	var submit_form = function( $form ) {
		var $wrapper = $form.closest( '.attended-course-info' ), data = {
			action: 'crate_attended_course_add_to_cart',
			nonce: ScriptData.crate_attended_course_add_to_cart_nonce,
			date: $form.find( 'select#attended-course-date-select' ).val(),
			pay_in_instalments: $form.find( 'input#pay-in-instalments-checkbox' ).is( ':checked' ) ? 1 : 0,
			quantity: $form.find( 'input.qty' ).val()
		};

		$wrapper.addClass( 'loading' );

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			var $notice_wrapper = $form.closest( '.attended-course-info' ).find( '.notices-wrapper' );

			add_notices( $notice_wrapper, response.notices );

			$wrapper.removeClass( 'loading' );

			if ( response.redirect ) {
				window.location.href = response.redirect
			}
		} );
	}

	var change_price = function( html ) {
		var $wrapper = $( '.attended-course-info' );

		$wrapper.addClass( 'loading' );

		$('.attended-course-price').find('.price').data('prices', html );
		currency.refresh_prices_currency();

		setTimeout( () => {
			$wrapper.removeClass( 'loading' );
		}, 400 );
	}

	var update_visible_information = function( $form ) {
		var value = $form.find( 'select#attended-course-date-select' ).val(),
			in_instalments = $form.find( 'input#pay-in-instalments-checkbox' ).is( ':checked' );

		clear_notices( $form.closest( '.attended-course-info' ).find( '.notices-wrapper' ) );

		if ( value ) {
			var data = $form.data( 'form-data' )[ value ];

			if ( data.enabled_pay_by_instalments ) {
				show_pay_by_instalments( $form );
			} else {
				hide_pay_by_instalments( $form );
			}

			if ( in_instalments ) {
				change_price( data.price_instalments );
			} else {
				change_price( data.price );
			}
		} else {
			var data = $form.data( 'form-data' ).default;

			hide_pay_by_instalments( $form );
			change_price( data.price );
		}
	}

	var show_pay_by_instalments = function( $form ) {
		$form.find( '#pay-in-instalments-form-wrapper' ).slideDown( anim_speed );
	}

	var hide_pay_by_instalments = function( $form ) {
		$form.find( '#pay-in-instalments-form-wrapper' ).slideUp( anim_speed );
		$form.find( 'input#pay-in-instalments-checkbox' ).prop( 'checked', false );
	}

	var add_notices = function( $wrapper, $html ) {
		clear_notices( $wrapper );
		$wrapper.html( $html );
	};

	var clear_notices = function( $wrapper ) {
		$wrapper.html( '' );
	};

	if ( $( 'body.single-attended_course' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = attended_course_add_to_cart;